import type { HTMLComponent } from "@commercekit/react";
import type { ProductAndCategoryDocumentDataPaymentMethodsItem } from "~/lib/prismic";

const WvPaymentMethodsRow: HTMLComponent<{
  paymentMethods: ProductAndCategoryDocumentDataPaymentMethodsItem[];
}> = ({ paymentMethods }) => {
  return (
    <div className="row no-gutters ml-lg-0 justify-content-center justify-content-md-start">
      {paymentMethods?.length
        ? paymentMethods.map((method) => (
            <div
              key={method.payment_name}
              title={method.payment_name || ""}
              className="col-auto d-flex align-items-center justify-content-center mb-3 mb-lg-0 px-05 pb-2"
            >
              <div className="footer__payment-logo h-100 d-flex align-items-center justify-content-center">
                <img
                  src={method.payment_icon.url || ""}
                  alt={method.payment_name || "Payment Method"}
                />
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default WvPaymentMethodsRow;
